module.exports = __webpack_public_path__ + "static/media/sound3.102727bb.mp3";